export const DATE_FORMAT = 'DD.MM.YYYY'
export const TODAY_DATE = new Date()
